export default __webpack_public_path__ + "static/media/marking--discrete--stop-line.926dabb3.png";